import 'core-js/stable';
import 'regenerator-runtime/runtime';

import detectJavaScript from './modules/detectJavaScript';
import fixMobileViewport from './modules/fixMobileViewport';

window.addEventListener('load', detectJavaScript());
window.addEventListener('load', fixMobileViewport());
